import React, { useEffect, useState } from 'react'
import useDates from 'services/hooks/useDate'
import { Box, InputAdornment, Icon } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
// import CalendarModal from "./calendarModal";
import { format, differenceInDays, parse, isValid } from 'date-fns'
import ACCalendarModal from './ACCalendarModal'

const ACCDatePicker = (props) => {
  // Props for calendar modal:
  // 1. disablePast: Boolean. to disable all dates that are in the past
  // 2. disableFuture: Boolean. to disable all dates that are in the future
  // 3. disabledDates: Array[DateString]. Format: dd MMMM yyyy
  // 4. restrictions: Number. The amount of number of days the range can be selected in a row.
  // 5. minDayFromToday: Number. The mininum number of today from today that the range picker should be available to be selected
  // 6. disableCertainDays. Arr[Number]. To specify which day of the week to disable in the calendar.
  // 7. startCycle: Date. The start date of a cycle. Use with endCycle. The dates which in the past of the startCycle date will be disabled
  // 8. endCycle: Date. The end date of a cycle. Use with startCycle. The dates which in the future of the endCycle date will be disabled
  // Available props for AdxInput
  // 9. label: for the input label
  // 10. disabled: Boolean. To control whether the date picker is disabled or not
  // Props for controlling value from parents
  // 10. values: Object. { startDate, endDate, duration }
  // 11. setValue: Function. Function to set variable "values".
  const {
    label,
    name,
    disabled,
    errorMessage,
    isErrorShown,
    setFieldTouched,
    values,
    cycleDate,
    ...calendarProps
  } = props

  const [calendarValue, setCalendarValue] = useState(new Date())
  const { currentMonth, nextMonth } = useDates({ date: calendarValue })
  const [openModal, setOpenModal] = useState(false)
  const [initialValue, setInitialValue] = useState(
    values
      ? isValid(parse(values.startDate, 'dd/MM/yyyy', new Date())) === false
        ? {
            startDate: values.startDate,
            endDate: values.endDate,
            duration: 0,
          }
        : {
            startDate: parse(values.startDate, 'dd/MM/yyyy', new Date()),
            endDate: parse(values.endDate, 'dd/MM/yyyy', new Date()),
            duration: values.duration,
          }
      : { startDate: new Date(), endDate: new Date(), duration: 1 }
  )

  const [selectedFirst, setSelectedFirst] = useState(
    values
      ? isValid(parse(values.startDate, 'dd/MM/yyyy', new Date())) === false
        ? ''
        : parse(values.startDate, 'dd/MM/yyyy', new Date())
      : new Date()
  )

  const [selectedSecond, setSelectedSecond] = useState(
    values
      ? isValid(parse(values.endDate, 'dd/MM/yyyy', new Date())) === false
        ? ''
        : parse(values.endDate, 'dd/MM/yyyy', new Date())
      : new Date()
  )

  const [selectedDuration, setSelectedDuration] = useState(
    values
      ? values.duration === 0
        ? 0
        : values.duration
      : differenceInDays(selectedSecond, selectedFirst) + 1
  )

  useEffect(() => {
    cycleDate(selectedFirst, selectedSecond)
  }, [selectedFirst, selectedSecond])

  return (
    <Box width={1}>
      <AdxInput
        disabled={disabled}
        label={label}
        size="standard"
        value={
          selectedFirst &&
          selectedSecond &&
          `${selectedFirst !== '' ? format(selectedFirst, `eee, dd/MM/yyyy`) : ''} - ${
            selectedSecond !== '' ? format(selectedSecond, `eee, dd/MM/yyyy`) : ''
          } (${selectedDuration === 1 ? `${selectedDuration} day` : `${selectedDuration} days`})`
        }
        placeholder={`DD/MM/YYYY - DD/MM/YYYY`}
        readOnly
        sxInput={{
          cursor: !disabled && 'pointer',
          '& .MuiInputBase-input': {
            cursor: !disabled && 'pointer',
          },
        }}
        endAdornment={
          <InputAdornment position="end">
            <Icon>insert_invitation</Icon>
          </InputAdornment>
        }
        onClick={() => {
          if (!disabled) {
            setOpenModal(true)
            if (setFieldTouched) {
              setFieldTouched(name)
            }
          }
        }}
        name={name}
        errorMessage={errorMessage}
        isErrorShown={isErrorShown}
      />
      <ACCalendarModal
        calendarProps={calendarProps}
        openModal={openModal}
        setOpenModal={setOpenModal}
        currentMonth={currentMonth}
        nextMonth={nextMonth}
        calendarValue={calendarValue}
        setCalendarValue={setCalendarValue}
        selectedFirst={selectedFirst}
        setSelectedFirst={setSelectedFirst}
        selectedSecond={selectedSecond}
        setSelectedSecond={setSelectedSecond}
        selectedDuration={selectedDuration}
        setSelectedDuration={setSelectedDuration}
        initialValue={initialValue}
        setInitialValue={setInitialValue}
        // cycleDate={cycleDate}
      />
    </Box>
  )
}

export default ACCDatePicker
